var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEmailSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3796_18453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8694 27.3915L35 44.1305L9.13048 27.3915V1.52199C9.11265 0.699403 9.76505 0.0181898 10.5876 0.000357045C10.6092 -7.09421e-05 10.6307 -7.09421e-05 10.6523 0.000357045H59.3476C60.1702 -0.0174758 60.8516 0.634919 60.8694 1.45751C60.8698 1.47905 60.8698 1.50059 60.8694 1.52214V27.3915Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13064 27.3912L0.000244141 21.3042L9.13064 12.1738V27.3912Z",
    fill: "#F6B445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 21.3042L60.8696 27.3912V12.1738L70 21.3042Z",
    fill: "#F6B445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8696 27.2547L70 21.3047V63.9132C69.9971 65.5273 69.3573 67.0749 68.2195 68.2198L57.8262 57.8264L41.087 41.0872L40.6609 40.4329L60.8696 27.2547Z",
    fill: "#FED049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.826 57.826L68.2194 68.2194C67.0745 69.3571 65.5269 69.997 63.9128 69.9998H6.08707C4.47298 69.997 2.92538 69.3571 1.78052 68.2194L12.1739 57.826L28.9129 41.087L29.339 40.4326L34.9999 44.1304L40.6607 40.4326L41.0869 41.087L57.826 57.826Z",
    fill: "#F6B445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3392 40.4329L28.9131 41.0872L12.1741 57.8263L1.78067 68.2196C0.642938 67.0748 0.00309739 65.5272 0.000244141 63.9131V21.3047L29.3392 40.4329Z",
    fill: "#FED049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7391 36.5216C61.8242 36.5216 69.9998 28.3459 69.9998 18.2608C69.9998 8.17563 61.8242 0 51.7391 0C41.6539 0 33.4783 8.17563 33.4783 18.2608C33.4783 28.3459 41.6539 36.5216 51.7391 36.5216Z",
    fill: "#49AAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.739 27.3919C50.8986 27.3919 50.2172 26.7105 50.2172 25.8701V15.0171L48.0183 16.4841C47.3192 16.9506 46.3742 16.7618 45.9077 16.0625C45.4411 15.3633 45.6299 14.4183 46.3292 13.9518L50.8944 10.9084C51.5935 10.4419 52.5385 10.6306 53.0048 11.3297C53.1717 11.5798 53.2608 11.8738 53.2608 12.1745V25.8701C53.2608 26.7105 52.5794 27.3919 51.739 27.3919Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3796_18453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmailSuccessIcon);
export default __webpack_public_path__ + "static/media/send-email-success-icon.192a4fe9775c93ea43d8b161ded7d975.svg";
export { ForwardRef as ReactComponent };